// Vuex
import store from '@/store.js';
// import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/alerts", data);
}

async function fetchUnRead(data) {
  const response = await Request('get', "api/alerts", data);
  if (response.data && response.data.status.isOK()) {
      store.commit("toreads", response.data.alerts.length);
  }
  return response;
}

async function rePush(id) {//提醒重推
    return Request('post', "api/alerts/re-push/"+id,);
}

export default {
    fetch,
    rePush,
    fetchUnRead
};